/*
 * CultureKings API
 */
if ((typeof CultureKings) === 'undefined') {
  CultureKings = {};
}

CultureKings.Notifications = function (options) {
  var action = options.action != null ? options.action : void 0;
  var message = options.message;

  toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: 'toast-bottom-left',
    preventDuplicates: true,
    onclick: null,
    showDuration: '300',
    hideDuration: '1000',
    timeOut: '5000',
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
  }

  switch (action) {
    case "close": {
      toastr.clear();
      break;
    }
    case "notice": {
      toastr.info(message);
      break;
    }
    case "error": {
      toastr.error(message);
      break;
    }
  }
};

// one-liner version
// retains latin-1 supplement chars as well as latin extended-a and latin extended-b
Shopify.handleize = function (str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

// Theme functions
window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navCategory: $('.nav-category'),

    // Index
    $homepageBanner: $('.js-marketing-banner'),

    // Product
    $productPage: $('.template-product'),
    $productImageThumbnails: $('.product-single__thumbnails'),
    $productImageThumbnail: $('.product-single__thumbnail'),

    // Collection
    $collectionPage: $('.template-collection'),

    // User
    $currencyPicker: $('.currency-picker'),

    // Cart
    $cartPage: $('.template-cart'),
    $cartCount: $('.cart-link__count'),
    $addToCartForm: $('.js-form-add-to-cart'),

    // Article
    $articlePage: $('.template-article')
  }
};

theme.init = function () {
  theme.goToNationalStore();
  theme.initMobileMenu();
  theme.initWishlist();
  theme.initTapcartQRCode();
  theme.initFixHeader();
  theme.cacheSelectors();
  theme.checkoutLoader();
  theme.addToCartLoader();
  theme.selectSize();
  theme.afterpayMarketingModal();
  theme.initCollectionAddToCart();
  theme.initAccordion();
  theme.initSocialShareButtons();
};

theme.goToNationalStore = function () {
  var isPDP = window.location.href.includes('/products/');
  function handleClose() {
    sessionStorage.removeItem('ck-display-banner');
  }


  var localisedUrls = {
    AU: window.location.href.replace('.com', '.com.au').replace('.co.nz', '.com.au'),
    NZ: window.location.href.replace('.com.au', '.co.nz').replace('.com', '.co.nz'),
    US: window.location.href.replace('.com.au', '.com').replace('.co.nz', '.com')
  };

  var bannerDetails = {
    AU: {
      img: '//www.culturekings.com.au/cdn/shop/t/3/assets/australian-flag-graphic.png?v=86195318928327144361497913750',
      url: localisedUrls.AU,
      alt: 'Switch to Culture Kings Australia website',
      text: 'Did you know we have a website for Australia?',
      content: 'Get localised offers, currency & delivery options.'
    },
    NZ: {
      img: '//www.culturekings.com.au/cdn/shop/t/3/assets/new-zealander-flag-graphic.png?v=73788668603934315281497913778',
      url: localisedUrls.NZ,
      alt: 'Switch to Culture Kings New Zealand website',
      text: 'Did you know we have a website for New Zealand?',
      content: 'GET LOCALISED OFFERS, NZD PRICING & BETTER DELIVERY OPTIONS.'
    },
    US: {
      img: '//www.culturekings.com.au/cdn/shop/t/3/assets/united-states-flag-graphic.png?v=152641534316242579931529542517',
      url: localisedUrls.US,
      alt: 'Switch to Culture Kings United States website',
      text: 'Did you know we have a website for The United States?',
      content: 'Get localised offers, currency & delivery options.'
    }
  };

  var $popupTemplate = $('#PopupChangeCountryTemplate');

  function showBanner(countryCode) {
    var details = bannerDetails[countryCode];
    var source = $popupTemplate.html();
    var template = Handlebars.compile(source);

    $.magnificPopup.open({
      items: {
        src: template(details)
      },
      callbacks: {
        close: handleClose
      },
      closeMarkup: '<button title="%title%" type="button" class="icon icon-cross popup--country-close-btn js-popup-close-button"></button>',
      type: 'inline',
    });

    // Using a custom markup breaks the close event from firing
    $('.js-popup-close-button').on('click', function () {
      // manually closing the popup
      $.magnificPopup.close();
    });
  }

  function doesQueryStringInclude(text) {
    return Boolean(window.location.search.split('&').find(function (item){ return item.toLowerCase().indexOf(text.toLowerCase()) !== -1 }));
  }

  var hasLocationBeenChecked = sessionStorage.getItem('ck-check-country');
  if (!hasLocationBeenChecked && !Shopify.isInternalTraffic) {
    $.ajax({
      url: window.location.origin + '/browsing_context_suggestions.json',
      type: 'GET',
      success: function (location) {
        var countryCode = location.detected_values?.country?.handle;
        sessionStorage.setItem('ck-check-country', 'true');
        sessionStorage.setItem('ck-user-country-code', countryCode);
        window.dispatchEvent(new Event('geoLocationReady'));

        // If currency and country code don't match (AUD / AU || NZD / NZ || USD / US), and only if customer are in one of those 3 countries
        if (
          Shopify.currency &&
          Shopify.currency.indexOf(countryCode) === -1 &&
          (countryCode === 'NZ' || countryCode === 'US' || countryCode === 'AU')
        ) {
          sessionStorage.setItem('ck-display-banner', countryCode);

          // Auto redirect if the traffic comes from social and FB ads
          if (
            doesQueryStringInclude('redirect=true') ||
            doesQueryStringInclude('utm_source=IGShopping') ||
            doesQueryStringInclude('utm_source=Linktree') ||
            doesQueryStringInclude('utm_source=instagram') ||
            doesQueryStringInclude('utm_source=Tik+Tok') ||
            doesQueryStringInclude('fbclid=')
          ) {
            window.location.href = localisedUrls[countryCode];
          } else if (!isPDP) {
            showBanner(countryCode);
          }
        }
      }
    });
  } else if (sessionStorage.getItem('ck-display-banner') && !isPDP) {
    var countryCode = sessionStorage.getItem('ck-display-banner');
    showBanner(countryCode);
  }
};

theme.selectSize = function () {
  var $form = $('.js-form-product-single');
  var $productSelect = $form.find('.js-product-option-input');
  var $addToCart = $form.find('.js-add-to-cart');

  $productSelect.prop('disabled', false);

  $productSelect.on('change', function (event, isInitialLoad) {
    var $this = $(this);
    var optionName = $this.data('option-name');
    $addToCart.removeClass('needVariant');
    $('#option-error-'+ optionName).remove();
    $this.removeClass('error');

    if ($this.val() === '') {
      $addToCart.addClass('needVariant');
      $this.addClass('error');
      $this.after('<div id="option-error-'+ optionName +'" class="has-text-danger">Please select ' + optionName + ' first</div>');
    } else {
      $productSelect.find('option:selected')?.text($this.val()?.split(' - ')[0]);
    }
  }).triggerHandler('change', true);

  $form.find('.needVariant').on('click', function () {
    var $this = $(this);
    if (!$productSelect.hasClass('error')) {
      $productSelect.each(function() {
        var optionName = $(this).data('option-name');
        if ($(this).val() === '') {
          $(this).addClass('error');
          $(this).after('<div id="option-error-'+ optionName +'" class="has-text-danger">Please select ' + optionName + ' first</div>');
        }
      });
    }
  });
};

theme.snapchatAccess = function (isForcedSoldOut) {
  if (!window.snapAccess) return;
  snapAccess.init({
    isForcedSoldOut: isForcedSoldOut || false,
    containerSelector: '.product-content-parent',
    addToCartSelector: '.js-add-to-cart',
    pinInputSelector: '.snap-pin-digit',
    pinCodeSelector: '.snapaccess__pin',
    addToCartTextSelector: '.btn__content',
    optionSelector: '.js-product-option-input',
    optionContainer: '.product-single__options',
  });
};

theme.afterpayMarketingModal = function () {
  var $afterpayOpenPopup = $('.js-afterpay-popup'),
    $laybuyOpenPopup = $('.js-laybuy-popup'),
    $klarnaOpenPopup = $('.js-klarna-popup'),
    $refundidOpenPopup = $('.js-refundid-popup');

  if ($afterpayOpenPopup.length) {
    $($afterpayOpenPopup).magnificPopup({
      items: {
        src: $('#AfterpayTemplate').html(),
        type: 'inline'
      }
    });
  }

  if ($laybuyOpenPopup.length) {
    $($laybuyOpenPopup).magnificPopup({
      items: {
        src: $('#LaybuyTemplate').html(),
        type: 'inline'
      }
    });
  }

  if ($klarnaOpenPopup.length) {
    $($klarnaOpenPopup).magnificPopup({
      items: {
        src: $('#KlarnaTemplate').html(),
        type: 'inline'
      }
    });
  }

  if ($refundidOpenPopup.length) {
    $($refundidOpenPopup).magnificPopup({
      items: {
        src: $('#RefundidTemplate').html(),
        type: 'inline'
      }
    });
  }
};

theme.productSingle = function (options, container) {
  var moneyFormat = options.money_format,
    variant = options.variant,
    isBundle = options.isBundle,
    override_lang_key = options.override_lang_key,
    product_id = $(container).data('product-id'),
    priceFactor = window[product_id] ? window[product_id].priceFactor || 1 : 1;

  // Selectors
  var $formContainer = $('.js-form-add-to-cart[data-product-id="' + product_id + '"]'),
    $productContainer = $('[data-product-id="' + product_id + '"]'),
    $addToCart = $formContainer.find('.js-add-to-cart'),
    $addToCartText = $addToCart.find('span.btn__content'),
    $productPrice = $productContainer.find('.js-price'),
    $comparePrice = $productContainer.find('.js-compare-price'),
    $afterpayPrice = $productContainer.find('.js-afterpay-price'),
    $laybuyPrice = $productContainer.find('.js-laybuy-price'),
    $priceWithFactor = $productContainer.find('.js-price-with-factor');

  $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));
  $priceWithFactor.html(Shopify.formatMoney(variant.price * priceFactor, moneyFormat));
  $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat));
  $afterpayPrice.html(Shopify.formatMoney(variant.price / 4 * priceFactor, moneyFormat));
  $laybuyPrice.html(Shopify.formatMoney(variant.price / 6 * priceFactor, moneyFormat));

  // Save % - Normal mark down
  $productContainer.find('.js-markdown-percentage').html(Math.round((variant.compare_at_price - variant.price ) * 100 / variant.compare_at_price));
  // Save % - Script (e.g. 3 for $99) discount or Shopify coupon discount
  $productContainer.find('.js-discount-percentage').html(Math.round((variant.price - variant.price * priceFactor) * 100 / variant.price));
  // Save % - Script discount or Shopify coupon discount on top of markdown
  $productContainer.find('.js-further-discount-percentage').html(Math.round((variant.compare_at_price - variant.price * priceFactor) * 100 / variant.compare_at_price));

  if (!variant.available) {
    $addToCart.addClass('color-red disabled').prop('disabled', true);
  } else {
    $addToCart.removeClass('color-red disabled').prop('disabled', false);
  }

  function getAddToCartText() {
    if (!variant.available) {
      return "Sold Out Online";
    } else if (override_lang_key) {
      return override_lang_key;
    }

    return isBundle ? 'ADD TO BUNDLE' : "Add to Cart";
  }

  $addToCartText.html(getAddToCartText());
};


theme.checkoutLoader = function () {
  theme.cache.$body.on('click', '.cart__checkout', function () {
    $(this).addClass('loading');
  });
};

theme.addToCartLoader = function () {
  var addToCart = '.js-add-to-cart:not(.needVariant, .js-add-to-progress)';

  theme.cache.$body.on('click', addToCart, function () {
    $(this).addClass('loading');
  });
};

theme.initFixHeader = function () {
  var $body = $('body');
  var $navbar = $('.navbar');
  var $secondaryNavbar = $('.navbar .header-secondary');
  var navbarHeight = $navbar.outerHeight();
  var pageName = window.location.pathname.split('/').pop();

  function handleScroll() {
    if (pageName.indexOf('size-chart') !== -1) return;
    if (this.scrollY > navbarHeight && this.oldScroll > this.scrollY){
      if(this.oldScroll - this.scrollY > 10){
        $body.addClass('has-navbar-fixed-top');
        $navbar.addClass('navbar-fixed-top');
        $secondaryNavbar.addClass('is-hidden-desktop');
      }
    } else {
      $body.removeClass('has-navbar-fixed-top');
      $navbar.removeClass('navbar-fixed-top');
      $secondaryNavbar.removeClass('is-hidden-desktop');
    }
    this.oldScroll = this.scrollY;
  }

  window.addEventListener('scroll', handleScroll, {passive: true});

  // Mobile Search bar
  var $searchNavBar = $('.navbar-search');
  $('.search-button-mobile').on('click', function () {
    window.removeEventListener('scroll', handleScroll);
    $searchNavBar.removeClass('is-hidden-touch');
    $('.navbar-search input').focus();
  });

  $('.close-search-mobile').on('click', function () {
    window.addEventListener('scroll', handleScroll, {passive: true});
    $searchNavBar.addClass('is-hidden-touch');
    $body.removeClass('body-overlay-search-bar');
    $('html').removeClass('body-overlay-search-bar');
  });

  // Dropdown click to open
  var $dropdown = $('.has-dropdown.is-hoverable');
  $dropdown.find('.navbar-link').on('click', function (e) {
    e.preventDefault();
    $(this).parent().addClass('is-active');
  })
  $dropdown.on('focusout', function (){
    $(this).removeClass('is-active');
  });
};

theme.initCollectionAddToCart = function () {
  var $sizeButton = $('.js-size-button');
  var $sizeSelect = $('.js-size-select');

  $sizeButton.off('click');
  $sizeSelect.off('change');

  $sizeButton.on('click', function () {
    var $this = $(this);

    if ($this.hasClass('is-sold-out')) return;

    var formData = new FormData();
    formData.append('id', $this.data('variantId'));
    formData.append('quantity', '1');
    if (!($this).parent().hasClass('size-hover-selector')) {
      $this.addClass('loading');
    }
    ShopifyAPI.addItemFromForm(formData, function () {
      ajaxCart.load();
      $this.removeClass('loading');
    }, function (form, XMLHttpRequest, textStatus) {
      $this.removeClass('loading');
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    })
  });

  $sizeSelect.on('change', function () {
    var $this = $(this);

    if (!$this.val()) return;

    var formData = new FormData();
    formData.append('id', $this.val());
    formData.append('quantity', '1');

    if($this.hasClass('select-to-cart')){
      $this.closest('form').submit();
    }else {
      ShopifyAPI.addItemFromForm(formData, function () {
        ajaxCart.load();
        $this.val('').change();
      }, function (form, XMLHttpRequest, textStatus) {
        $this.val('').change(); // clear select value when error happens
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      })
    }
  });
};

theme.initMobileMenu = function () {
  $('.js-search-bar-trigger').on('click focus', function () {
    $('.js-drawer-close').click();
    $('.search-button-mobile').trigger('click');
  });
};

theme.initTapcartQRCode = function () {
  if (window.innerWidth >= 768) {
    const observer = new MutationObserver(() => {
      const $qrImage = $('.tc-frame.svelte-deweka img');
      const $getAPPBtn = $('.tc-button.svelte-deweka');

      if ($qrImage.length) {
        observer.disconnect(); // Stop observing
        $getAPPBtn.on('click', function () {
          window.open('/pages/culture-kings-app', '_blank');
        });
        $qrImage
          .css('cursor', 'pointer')
          .on('click', function () {
              window.open('/pages/culture-kings-app', '_blank');
          })
          .hover(
            function () {
              $(this).css('filter', 'brightness(1.1)');
            },
            function () {
              $(this).css('filter', 'none');
            }
          );
      }
    });

    // Start observing the document
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}
/**
 * Create a slider
 * @param slider
 * @param settings {prevNextButtons, initialIndex, dots, autoPlayTime, enabledMobileCarousel, isSmooth}
 * if prevNextButtons is true, show the prev and next icon buttons
 * if dots are true, show dots navigation
 * initialIndex is which item that you want to show as a current one
 * autoPlayTime: how many milliseconds to autoplay carousel
 * if enabledMobileCarousel is true create slider in mobile
 * if isSmooth is false instant scroll
 */
theme.createSlide = function ($slider, settings ) {
  $slider.addClass("ck-slider").children().addClass('ck-slider-slide');
  const $sliderItems = $slider.find('.ck-slider-slide');
  if(($sliderItems.length < 2  || window.innerWidth < 768) && !settings.enabledMobileCarousel) return;
  const sliderWidth = $slider.width();
  const width = $sliderItems.first().outerWidth();
  const step = Math.floor(sliderWidth / width);
  const initialIndex = Number(settings.initialIndex);
  const maxScrollDistance = Math.round(width * $sliderItems.length - sliderWidth);
  const hasPrevNextBtn = settings.prevNextButtons && sliderWidth < width * $sliderItems.length - 1;
  //autoplay
  let autoplay = null;
  const autoPlayTime = settings.autoPlayTime;
  let autoPlaycurrentIndex = initialIndex;

  //get current item position
  function getCurrentPos() {
    return Math.round($slider.scrollLeft() / width);
  }

  //scroll to what position
  function scrollTo(index) {
    if(settings.isSmooth) {
      $slider.get(0).scrollTo({left: width * index, behavior: 'smooth'});
    }else {
      $slider.scrollLeft(width * index);
    }
  }

  //on slider scroll
  function onSliderScroll () {
    if(!settings.dots && !hasPrevNextBtn) return;
    let previousIndex = initialIndex;
    const $sliderDots = $slider.find('.ck-slider-dot');
    $slider.on("scroll", function() {
      toggleStatus();

      if(!settings.dots) return;
      const currentIndex = getCurrentPos();
      if(currentIndex !== previousIndex){
        $sliderDots.removeClass('current').slice(currentIndex, currentIndex + 1).addClass('current');
        previousIndex = currentIndex;
        toggleStatus();
      }
    });
  }

  function toggleStatus(index) {
    if(!hasPrevNextBtn || autoPlayTime > 0) return;
    const $prev = $slider.find('.prev');
    const $next = $slider.find('.next');
    const currentIndex = index || getCurrentPos();
    const scrollLeft = Math.round($slider.scrollLeft());
    if(currentIndex === 0 && scrollLeft === 0) {
      $prev.prop('disabled', true);
      $next.prop('disabled', false);
    }else if(currentIndex === $sliderItems.length - 1 || maxScrollDistance <= scrollLeft) {
      $prev.prop('disabled', false);
      $next.prop('disabled', true);
    }else {
      $prev.prop('disabled', false);
      $next.prop('disabled', false);
    }
  }

  // previous and next button click
  function onButtonClick(direction) {
    if(autoPlayTime > 0) {
      autoRotateSlides(direction);
      return;
    }
    const currentIndex = getCurrentPos();
    if(direction === "prev") {
      //previous button click
      scrollTo(currentIndex - step);
    }
    if(direction === "next") {
      //next button click
      scrollTo(currentIndex + step);
    }
    toggleStatus();
  }

  function autoRotateSlides(direction) {
    if(direction === "prev") {
      if(autoPlaycurrentIndex === 0 ) {
        autoPlaycurrentIndex = $sliderItems.length - 1;
      }else {
        autoPlaycurrentIndex = autoPlaycurrentIndex - step;
      }
    } else {
      if(autoPlaycurrentIndex === $sliderItems.length - 1 ) {
        autoPlaycurrentIndex = 0;
      } else {
        autoPlaycurrentIndex = autoPlaycurrentIndex + step;
      }
    }
    scrollTo(autoPlaycurrentIndex);
  }

  // autoPlay
  function play() {
    clearInterval(autoplay);
    autoplay = setInterval(autoRotateSlides, autoPlayTime);
  }

  // autoPlay
  function pause() {
    clearInterval(autoplay);
  }

  function init() {
    // autoPlay
    if(autoPlayTime > 0) {
      play();
      //when mouse on the slider pause autoplay
      $slider.on('mouseover focusin', function (){
        pause();
      });
      //when mouse leave the slider resume autoplay
      $slider.on('mouseleave focusout', function (){
        play();
      });
    }

    // prev and next buttons
    if(hasPrevNextBtn) {
      $slider.append('<button class="ck-slider-btn prev" aria-label="prev"><span class="icon icon-arrow-left size-medium"></span></button>');
      $slider.append('<button class="ck-slider-btn next" aria-label="next"><span class="icon icon-arrow-right size-medium"></span></button>');
      const prevButton = $slider.find('.prev');
      const nextButton = $slider.find('.next');
      prevButton.on( "click", function() {
        onButtonClick('prev');
      });
      nextButton.on( "click", function() {
        onButtonClick('next');
      });
    }
    // dots
    if(settings.dots) {
      $slider.append('<ol class="ck-slider-dots"></ol>');
      const $dots = $slider.find('.ck-slider-dots');
      $sliderItems.each(function(index) {
        if(index === initialIndex) {
          $dots.append(`<li class="ck-slider-dot current" data-index=${index} aria-label="dot"></li>`);
        }else {
          $dots.append(`<li class="ck-slider-dot" data-index=${index} aria-label="dot"></li>`);
        }
      });
      const $sliderDots = $slider.find('.ck-slider-dot');
      $sliderDots.on("click", function (){
        const $this = $(this);
        scrollTo($this.data('index'));
      });
    }

    if(initialIndex !== 0) {
      scrollTo(initialIndex);
    }
    toggleStatus();
    onSliderScroll();
  }
  init();
};
/**
 * init slider
 * @param slider
 * @param settings {prevNextButtons, initialIndex, dots, autoPlayTime, enabledMobileCarousel, isSmooth}
 * if prevNextButtons is true, show the prev and next icon buttons
 * if dots are true, show dots navigation
 * initialIndex is which item that you want to show as a current one
 * autoPlayTime: how many milliseconds to autoplay carousel
 * if enabledMobileCarousel is true create slider in mobile
 * if isSmooth is false instant scroll
 */
theme.initSlider = function (selector, options) {
  var $slider = selector ? $(selector) : $('.columns.scrollable:not(.no-slider-init)');
  const settings = jQuery.extend({
    prevNextButtons: true,
    initialIndex: 0,
    dots: false,
    autoPlayTime: 0,
    enabledMobileCarousel: false,
    isSmooth: true
  }, options);

  if($slider.length) {
    $slider.each(function () {
      const $this = $(this);
      // destroy first
      if($this.hasClass("ck-slider")) {
        $this.removeClass("ck-slider");
        $this.find('.ck-slider-slide').removeClass("ck-slider-slide");
        $this.find('.ck-slider-btn').remove();
      }
      theme.createSlide($this, settings);
    });
  }
};

// Init accordions
theme.initAccordion = function () {
  var $accordionSection = $('.accordion-section');
  $accordionSection.find('.details-summary').off('click').on('click', function () {
    var $this = $(this);
    if ($this.parent().hasClass('opened')) {
      $this.next().stop().slideUp(300, function () {
        $this.parent().removeClass('opened').attr('aria-expanded','false');
      });
    } else {
      $this.next().stop().slideDown(300, function () {
        $this.parent().addClass('opened').attr('aria-expanded','true');
      });
    }
  });
};

window._AutofillCallbackHandler = window._AutofillCallbackHandler || function(){}

// Social share buttons
theme.initSocialShareButtons = function () {
  var $socialButtons = $('.js-social-button');

  $socialButtons.on('click.js-social-button', function (e) {
    e.preventDefault();

    var $el = $(this),
      url = $el.attr('href');

    windowPopup(url, 680, 460);
  });

  function windowPopup(url, width, height) {
    var left = (screen.width / 2) - (width / 2),
      top = (screen.height / 2) - (height / 2);

    window.open(
      url,
      "",
      "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
    );
  }
};

// Add to cart in Quick view, in bundles only adds to a staging placeholder
theme.initQuickViewAddToCart = function () {
  $('.js-add-to-progress').on('click', function() {
    var $this= $(this);

    if ($this.hasClass('needVariant')) return;
    if ($this.prop('disabled')) return;

    var selectedVariantId = $this.closest('form').find('.js-product-variant-id-input').val();

    if (selectedVariantId) {
      window.dispatchEvent(new CustomEvent('addToBundle', { detail: { variantId: selectedVariantId } }));
    }
  });
};

// Swat is the wishlist plus SDK variable. We want to make sure it exist before use it.
theme.useSwat = function (callback) {
  if (window._swat) {
    callback(window._swat);
    return;
  }
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push((swat) => {
    callback(swat);
  });
}

theme.initWishlist = function () {
  function getWishlists(swat) {
    swat.fetchLists({
      callbackFn: function(response) {
        var $wishlistCount = $(".header-wishlist-count");
        var $wishlistHeaderIcon = $('.wishlist span.icon');

        const { wishListProductIds, wishListCollections } = response.reduce(function (acc, list) {
          const listItem = {lid: list.lid, lname: list.lname, products: []};
          list.listcontents.forEach(function (item) {
            acc.wishListProductIds.push(item.empi.toString());
            listItem.products.push({id: item.empi.toString(), variantId: item.epi.toString(), image: item.iu, handle: item.du, title: item.dt});
          })

          acc.wishListCollections.push(listItem);
          return acc;
        }, {
          wishListProductIds: [],
          wishListCollections: []
        });
        window.Shopify.wishlist = { wishListProductIds, wishListCollections };
        // Dispatch an event to let all listeners to know the list updated
        window.dispatchEvent(new CustomEvent('wishlistUpdated'));
        // if more than 9
        var currentCount = wishListProductIds.length <= 9 ? wishListProductIds.length : "9+"

        if(wishListProductIds.length > 0){
          $wishlistHeaderIcon.removeClass('icon-wishlist-off').addClass('icon-wishlist-on');
          $wishlistCount.text(currentCount);
        } else {
          $wishlistHeaderIcon.removeClass('icon-wishlist-on').addClass('icon-wishlist-off');
          $wishlistCount.text('');
        }
      },
      errorFn: function(err){
        console.error(err);
      }
    })
  }

  theme.useSwat(function (swat) {
    getWishlists(swat);

    window.addEventListener('getLatestWishLists', function() {
      getWishlists(swat);
    }, { passive: true });
  })
};

// Initialize Theme's JS on docready
$(theme.init);
